import { createAction } from "@reduxjs/toolkit";

export const emptyUserCart = createAction('emptyUserCart');
export const setPlacedOrders = createAction('setPlacedOrders');